import React from 'react';
import PrintableFullReport from '../../components/printableFullReport';
import moment from 'moment';
import {formatCurrency, formatStaticCurrency} from 'helpers/currencyHelper.jsx';

import ReportApi from 'api/report.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';

import events from 'lib/events';

import SummarySectionPOSDate from '../../components/summarySectionPosDate.jsx';
class AnalysesByEmployeeSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {};
  export = () => {
    let filters = this.props.filters;

    ReportApi.getWaterAnalysesByEmployeeExport(
      this.props.intl.locale,
      filters.dateFrom,
      filters.dateTo,
      filters.branch,
    );
  };

  render() {

    let carts;
    let tableRows;
    let data = this.props.data;
    let {formatMessage} = this.props.intl;

    if(data && Object.keys(data).length) {
      let summary = [
				{title: formatMessage({id: 'general.total.employees'}), value: data.TotalEmployees},
				{title: formatMessage({id: 'general.total.analyses'}), value: data.TotalAnalyses},
				{title: formatMessage({id: 'reports.average.analyses.employee'}), value: data.AvgAnalysesPerEmployee},
				{title: formatMessage({id: 'reports.analyses.active.customers'}), value: data.TotalActiveAnalyses},
        {title: formatMessage({id: 'reports.analyses.inactive.customers'}), value: data.TotalInactiveAnalyses},
      ];

      if(this.props.POSActive) {
        summary.push({title: formatMessage({id: 'general.total.sales'}), value: formatCurrency(data.TotalSales)});
      }

      carts = summary.map((cart, i) =>
        <div className={'col-sm-4 ' + (cart.class ? cart.class : '')} key={i} >
          {cart.title} <br />
          <span>{cart.value}</span>
        </div>
			);

      tableRows = data.Employees.map((row, i) =>
        <tr key={i} className={i % 2 !== 0 ? 'gray-row' : ''}>
          <td>{row.Name}</td>
          <td>{row.Store}</td>
          <td className="table-number">{row.AnalysesCount}</td>
          <td className="table-number">{row.AnalysesWithProblemsCount}</td>
        </tr>
			);

    }

    return <div>
      <div className="summary-container">
        <h2><FormattedMessage id="reports.report.summary"/></h2>
        <span className={data && Object.keys(data).length ?
          'summary-date' :
          'not-show'}> | <FormattedMessage id="general.date.range.labelled"
                                           values={{
                                             start: moment(this.props.filters.dateFrom)
                                               .format(dateTimeFormats.numeralDate),
                                             end: moment(this.props.filters.dateTo)
                                               .format(dateTimeFormats.numeralDate),
                                           }}/>
        </span>
        <br/>
        <p><FormattedMessage id="reports.reveal.report.summary"/></p>
        <SummarySectionPOSDate POSActive={this.props.POSActive} dealer={this.props.dealer} />
        {this.props.showNoDataMessage ?
          <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
        <div className="container-fluid custom-container-margins">
          <div className={carts && Object.keys(carts).length ? 'row' : 'not-show'}
               id="row-no-padding">
            {carts}
          </div>
          <div className={data && Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
            <table className="summary-table">
              <tbody>
                <tr className="table-title">
                  <th className="bigger-row"><FormattedMessage id="general.employee.name"/></th>
                  <th><FormattedMessage id="general.store"/></th>
                  <th className="column-custom-width table-number"><FormattedMessage id="general.analyses"/></th>
                  <th className="column-custom-width table-number"><FormattedMessage id="general.analyses.problems"/></th>
                </tr>
                {tableRows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='col-sm-12 button-group'>
        <button className='btn btn-primary pull-right'
                onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
      </div>
    </div>;
  }
}

export default injectIntl(AnalysesByEmployeeSummary);
